import fileListViewerTemplate from './file-list-viewer.tpl.html';
import './file-list-viewer.less';
import { fileTreeComponentModule } from '../file-tree/file-tree';
import { markdownComponentModule } from '../markdown/markdown';
import { codemirrorComponentModule } from '../codemirror/codemirror';
import { codemirrorOptionsComponentModule } from '../codemirror/codemirror-options';
import { codeFileModelModule } from '../../models/code-file';
import { isImageFile } from '../../utils/file-utils/image-file-utils';

export const fileListViewerComponentModule = angular
  .module('Q.components.file-list-viewer', [
    codeFileModelModule,
    fileTreeComponentModule,
    markdownComponentModule,
    codemirrorComponentModule,
    codemirrorOptionsComponentModule,
  ])

  .component('fileListViewer', {
    bindings: {
      files: '<',
      changedFiles: '<',
      reviewMode: '<',
    },
    controller: 'FileListViewerCtrl',
    template: fileListViewerTemplate,
  })

  .controller(
    'FileListViewerCtrl',
    function FileListViewerCtrl(codemirrorOptions, AdvancedCodeSolutionFile) {
      const ctrl = this;

      ctrl.$onInit = () => {
        if (!ctrl.files || !ctrl.files.includes(ctrl.selectedFile)) {
          let file = null;
          // pick something else
          if (ctrl.files && ctrl.files.length) {
            if (ctrl.changedFiles && ctrl.changedFiles[0]) {
              file = ctrl.changedFiles[0];
            } else {
              file =
                AdvancedCodeSolutionFile.initialLayout(ctrl.files)[0] ||
                ctrl.files[0];
            }
          }
          ctrl.selectFile(file);
        }

        ctrl.$onChanges = ctrl.$onInit;
      };

      ctrl.selectFile = (file) => {
        if (file && ((file.disabled && !ctrl.reviewMode) || file.directory))
          return;
        ctrl.selectedFile = file;
        ctrl.isMarkdown = file && /\.(md|markdown)$/.test(file.path);
        ctrl.isImage = file && isImageFile(file);
        ctrl.codemirrorOpts = file && codemirrorOptions.createOpts(file.path);
      };
    },
  );
